// ============================================================================
// post-client-mod -- useTags Hook
//
// 获取标签列表。
// ============================================================================
import { useState, useEffect, useCallback } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 获取标签列表
 */
export function useTags() {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchTags = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await getPostApiClient().getTags();
            setTags(result);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '获取标签列表失败';
            setError(message);
            setTags([]);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchTags();
    }, [fetchTags]);
    return {
        tags,
        loading,
        error,
        refresh: fetchTags,
    };
}
//# sourceMappingURL=use-tags.js.map